<div class="m-4">

  <!-- <form (ngSubmit)="otherDocumentsFormSub()" #f="ngForm"> -->
  <div class="row" class="font-weight-bold mb-4">
    Company Description
  </div>
  <div [hidden]="disableFields">
    <!-- <textarea spellcheck="true"  [(ngModel)]="description" name="companyDesc" [froalaEditor]="options"
      #companyDesc="ngModel" required></textarea> -->
    <kendo-editor [(ngModel)]="description" name="companyDesc" #companyDesc="ngModel" required>


      <kendo-toolbar>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
        <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
        <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
        <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
        <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
        <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
          <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorPrintButton></kendo-toolbar-button>
        <kendo-toolbar-buttongroup>
          <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
          <kendo-toolbar-button title="Upload’s Image at cursor point" text="Upload Image"
            (click)="openotherimageuploaddialog()"></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
      </kendo-toolbar>



    </kendo-editor>


    <app-upload-image-dialog #otherimageupload [editor]="otherdockendoeditor"></app-upload-image-dialog>
  </div>
  <div *ngIf="disableFields" class="border p-2" [innerHtml]="description | keepHtml"></div>
  <span class="invalid-message" *ngIf="(companyDesc.touched) && companyDesc.errors?.required">
    **Field is required
  </span>
  <div class="row" class="font-weight-bold mb-4 mt-4">
    Upload Documents
  </div>

  <div>
    <div class="row">
      <div class="col-md-12 p-0 pr-2 processing-dropdown">
        <h6>Document Type</h6>
      </div>
    </div>
    <div class="row">
      <div class="col-3 px-0">
        <p-dropdown [disabled]="disableFields" [options]="documentTypes" placeholder="Select Category"
          [(ngModel)]="selectedDocType" optionValue="code" optionLabel="name"></p-dropdown>
      </div>
      <div class="col-4">
        <!-- <app-file-upload style="width: 100%;" [configurations]="configurations"></app-file-upload> -->
        <p-fileUpload [disabled]="disableFields || !selectedDocType" #createUploader name="demo[]" mode="basic" chooseLabel="Browse"
          [auto]="true" customUpload="true" (uploadHandler)="onUpload($event,createUploader)" [accept]="acceptedTypes"
          invalidFileTypeMessageSummary=""
          invalidFileTypeMessageDetail="Unaccepted format. PDF, JPG, JPEG, and PNG formats are allowed" showUploadButton="false"
          showCancelButton="false" maxFileSize="10485760">
        </p-fileUpload>
        <label>{{acceptedTypesText}}</label>
      </div>
    </div>
    <p-table [value]="uploadedDocuments" styleClass="pt-2" *ngIf="uploadedDocuments.length > 0">
      <ng-template pTemplate="header">
        <tr>
          <th colspan="2">Document Name</th>
          <th colspan="2">Document Type</th>
          <th>Actions </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-doc>
        <tr>
          <td colspan="2" style="padding: 0!important;">
            <div class="col-9 d-inline-block fileNameBox">{{doc.fileName}} </div>
          </td>
          <td colspan="2" style="padding: 0!important;">
            <div class="col-9 d-inline-block fileNameBox">{{doc.fileCategory.description}} </div>
          </td>

          <td>
            <button pButton type="button" (click)="openDoc(doc.fileLocation)"
              class="p-button-icon-only bg-white border-0 text-secondary d-inline">
              <mat-icon class="mr-1 icn" matTooltip="View Document" class="material-icons">visibility</mat-icon>

            </button>

            <button pButton type="button" icon="pi pi-download" pTooltip="Download" (click)="download(doc)"
              class="p-button-text p-button-rounded"></button>

            <button pButton type="button" (click)="confirmDelete(doc)" [disabled]="disableFields"
              class="p-button-icon-only bg-white border-0 text-secondary d-inline">
              <mat-icon class="mr-1 icn" matTooltip="Delete Document" class="material-icons">delete</mat-icon>
            </button>

          </td>


        </tr>

      </ng-template>
    </p-table>

    <div *ngIf="uploadedDocuments.length == 0" class="mt-3 p-2 border">
      Not uploaded any additional documents yet.
    </div>

  </div>
  <div class="row" class="font-weight-bold mb-4 mt-4">
    Petition Fees Info
  </div>
  <div class="row mb-4 mt-4">
    <div class="row w-75" *ngFor="let item of company.petitionFeesInfo; let idx = index">
      <div class="form-group col-md-11" name="question">
        {{item.question}}
      </div>
      <div class="form-group col-md-1">
        <mat-slide-toggle (change)="toggle(idx)" [disabled]="disableFields" [checked]="item.isEnabled" name="item.id">
        </mat-slide-toggle>
      </div>
    </div>
  </div>
  <!-- </form> -->
</div>

<div class="row">
  <div class="col-6"></div>
  <div class="col text-right">
    <button (click)="onCancel()" pButton type="button" class="align-top mr-4 p-button-secondary">
      Cancel
    </button>

    <div class="border-right d-inline-block mr-4" style="height:46px"></div>
    <button (click)="onPrevious()" class="im-btn im-btn-primary im-btn-md" [disabled]="">
      Previous
    </button>
    <!-- <button type="submit" (click)="otherDocumentsFormSub()" class="im-btn im-btn-primary im-btn-md mx-2">
      Save
    </button>
    <button *ngIf="this.currentState != 'ACTV'" (click)="onNext()" class="im-btn im-btn-primary im-btn-md"
      [disabled]="">
      Next
    </button> -->
    <button (click)="otherDocumentsFormSub()" type="submit" class="im-btn im-btn-primary im-btn-md mx-2">
      Finish
    </button>

  </div>
</div>

<p-confirmDialog header="Delete"></p-confirmDialog>